








































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDocumentImageSource } from "../../../../domain/document";
import { Color, LineStyle, LineKinds, Size } from "../../../../domain/drawing";
import { DrawableCanvas } from "../../../drawing";
import { DialogMixin } from "../../../system/mixins";

@Component({
  components: {
    DrawableCanvas,
  },
})
export default class SignDialog extends Mixins(DialogMixin) {
  $refs!: {
    canvas: DrawableCanvas,
  };

  @Prop({ default: "" })
  name: string;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  data(): any {
    return {
      size: null as Size,
      result: null as string,
    };
  }
  size: Size;
  result: string;

  get title(): string {
    return this.name + "署名";
  }

  get canvasLineStyle() {
    return new LineStyle(new Color("#000000"), LineKinds.Normal, 2);
  }

  get canvasSize(): Size {
    return this.size ? new Size(this.size.width * this.scale, this.size.height * this.scale) : undefined;
  }

  get scale(): number {
    const viewPortSize = this.getViewPortSize();
    return this.size ? viewPortSize.width * .9 / this.size.width : 1;
  }

  getViewPortSize(): Size {
    return new Size(Math.max(document.documentElement.clientWidth, window.innerWidth), Math.max(document.documentElement.clientHeight, window.innerHeight));
  }

  async show(size: Size): Promise<string> {
    return this.showModal(async () => {
      this.size = size;
      this.result = null;
      await this.waitHidden();
      return this.result;
    });
  }

  async register(): Promise<void> {
    this.result = this.$refs.canvas.toImageText();
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }

  reset(): void {
    this.$refs.canvas.reload();
  }
}
